import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material';
import { Injectable } from '@angular/core';
import { SessionTimeoutDialogComponent } from '../components/session-timeout-dialog/session-timeout-dialog.component';
import { User } from '../../_models/user.model';
import { Constants } from '../../shared/constants';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class SessionManagementService {


  sessionTimeoutDialogRef: MatDialogRef<SessionTimeoutDialogComponent>;
  sessionConfig = { timeOut: (5 * 60 * 1000), warnAt: (2 * 60 * 1000) };

  constructor(private authenticationService: AuthenticationService,
    public sessionTimeoutDialog: MatDialog,
    private router: Router) { }


  configure(user: User, options: any): void {
    if (options) {
      this.sessionConfig.timeOut = options.timeOut;
      this.sessionConfig.warnAt = options.warnAt;
    }
    console.log('sessionConfig: ' + this.sessionConfig.timeOut);
    this.extendSession({ 'user': user.guid, 'expires': '' });
  }

  getSessionContext(): any {
    if (sessionStorage.getItem(Constants.SESSION_CONTEXT)) {
      return JSON.parse(sessionStorage.getItem(Constants.SESSION_CONTEXT));
    } else {
      console.log('No SESSION_CONTEXT in Session Storage');
      this.authenticationService.logout(Constants.LogoutReason_INACTIVE);
    }
  }

  extendSession(sContext?: any): void {

    const sessionContext = sContext == null ? this.getSessionContext() : sContext;

    const d = new Date();
    d.setTime(d.getTime() + (this.sessionConfig.timeOut * 60 * 1000));
    if(sessionContext){
      sessionContext.expires = d.toUTCString();
      console.log('Expiry Time: ' + d.toUTCString());
      sessionStorage.setItem(Constants.SESSION_CONTEXT, JSON.stringify(sessionContext));
    }
  }

  checkSessionExpiration(): void {

    const sessionContext = this.getSessionContext();

    const sessionWarnTime = new Date(sessionContext.expires);
    sessionWarnTime.setTime(sessionWarnTime.getTime() - (this.sessionConfig.warnAt * 60 * 1000));

    const sessionExpireTime = new Date(sessionContext.expires);
    const currentTime = new Date();

    console.log('Current Time: ' + currentTime.toUTCString());
    console.log('Warning Time: ' + sessionWarnTime.toUTCString());
    console.log('Expiry Time: ' + sessionExpireTime.toUTCString());

    if (currentTime.getTime() >= sessionWarnTime.getTime()) {
      console.log('Session Timeout Check');
      // If the session has expired open the alert.
      if (this.sessionTimeoutDialogRef) {
        // Alert was already shown. If the session expired sign the user out.
        if (currentTime.getTime() >= sessionExpireTime.getTime()) {
          this.authenticationService.logout(Constants.LogoutReason_INACTIVE);
        }
      } else {
        console.log('Time to warn the user');
        this.openDialog(sessionContext);
      }
    }

  }

  private openDialog(sessionContext: any): void {
    this.sessionTimeoutDialogRef = this.sessionTimeoutDialog.open(SessionTimeoutDialogComponent, {
      width: '550px',
      data: {}
    });

    this.sessionTimeoutDialogRef.afterClosed().subscribe(result => {
      this.extendSession(sessionContext);
      this.sessionTimeoutDialogRef = null;
    });
  }
}
